import React from 'react';
import { Body, Box, Heading } from '@hover/blueprint';
import { chakra } from '@hover/blueprint/chakra';
import { PARTNER_BEACON_ORDER_PAGE_VIDEO_SRC } from '../../../constants';

const Video = chakra('video');

const EstimateToOrder = () => (
  <Box flexDir="column" textAlign="center">
    <Heading size={600}>Estimate To Order</Heading>
    <Body size={500} mb={9}>
      Auto-calculate the precise amount of materials you need using 3D+
      measurements and seamlessly submit the order to your local Beacon branch
      with Pro+.
    </Body>
    <Video controls loop className="shared-hero__video" mb={9}>
      {PARTNER_BEACON_ORDER_PAGE_VIDEO_SRC.map(({ src, type }) => (
        <source src={src} type={type} key={type} />
      ))}
    </Video>
    <Body size={500}>
      It’s simple: Take 8 photos of any property using the Beacon 3D+ app.
      Choose your products and automatically create a material order list. Once
      done seamlessly submit your order on Beacon Pro+ with a click of a button.
    </Body>
  </Box>
);

export default EstimateToOrder;
